
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'FilterWrapper',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['disable'],
    watch: {
      disabled() {
        this.$emit('disable');
      },
    },
  });
